const baseurl = {
  apiUrl: process.env.REACT_APP_API_BASE_URL,
  baseUrl: process.env.REACT_APP_BASE_URL,
  logoHref: process.env.REACT_APP_LOGO_HREF,
};

export const PATH = {
  baseApi: baseurl.apiUrl,
  base: baseurl.baseUrl,
  logoHref: baseurl.logoHref,
};
